import React from "react";
import { useSelector } from "react-redux";
import { SidebarProvider } from "@/components/ui/sidebar";
import GuardianSidebar from "./GuardianSidebar";
import GuardianHeader from "./GuardianHeader";
import { useSuspensionCheck } from "@/Teacherdashboard/useSuspensionCheck";
import { Loader2 } from "lucide-react";
import SuspensionWarning from "@/Teacherdashboard/SuspensionWarning";
import SchoolCalendar from "@/components/SchoolCalendar";

const GuardianSchoolCalendar = () => {
  const user = useSelector((state: any) => state.users?.currentUser || {});
  const { selectedStudent } = user;
  const { isSuspended, isLoading, schoolName: suspendedSchoolName, schoolID, hasValidClaims } = useSuspensionCheck();

  if (isLoading) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <GuardianSidebar />
          <div className="flex flex-col flex-1 h-full">
            <GuardianHeader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <div className="flex items-center justify-center h-[60vh]">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  if (isSuspended) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <GuardianSidebar />
          <div className="flex flex-col flex-1 h-full">
            <GuardianHeader />
            <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
              <SuspensionWarning schoolName={suspendedSchoolName} />
            </main>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  // Use selected student's school ID if available, otherwise fallback to the one from suspension check
  const targetSchoolID = selectedStudent?.schoolID || (hasValidClaims ? schoolID : null);

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <GuardianSidebar />
        <div className="flex flex-col flex-1 h-full">
          <GuardianHeader />
          <main className="flex-1 overflow-y-auto min-h-0 p-4 md:p-6">
            <SchoolCalendar schoolID={targetSchoolID} />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default React.memo(GuardianSchoolCalendar);
